<template>
  <div class="havePermission">
    <!-- <PageNav :slider="slider" :openMenu="openMenu"> -->
    <el-main>
      <div class="page-havePermission">
        <p class="title">{{ $t("havePermission.a1") }}</p>
        <div class="img">
          <img src="../../assets/images/img-havePermission.png" alt />
        </div>
        <p style="font-size: 14px; color: #999">数据请求中，请稍后...</p>
        <!-- <p class="font-lightgray h3">
          <span class="time">{{ time }}</span
          >{{ $t("havePermission.a2") }}
        </p> -->
        <!-- <el-button type="primary" @click="jump">{{ $t("havePermission.a3") }}</el-button> -->
      </div>
    </el-main>
    <!-- </PageNav> -->
  </div>
</template>

<script>
// import PageNav from "../../components/Nav/nav.vue";
import storePermission from "./Permission.js";
import storeHome from "../Home/home.js";
import axios from "axios";
import { saveGraySchoolFlag } from "../../bootstrap/graySchoolRouting";
import { STORAGE_KEYS } from "../../constants/storageKeys";
export default {
  name: "havePermission",
  data() {
    return {
      istemporaryclose: "",
      temporaryclosetip: "",
      openMenu: ["1"],
      time: 3,
      original_token: "",
      staffer_id: "",
      isPush: false,
      timer: "",

      crmLoginData: {
        token: "",
        re_postbe_id: "",
        company_id: "",
        marketer_id: "",
        staffer_id: "",
        school_id: "",
        postbe_crmuserlevel: "",
        language_type: "",
      },
    };
  },
  components: {
    // PageNav,
  },
  created() {
    this.original_token = this.$route.query.token;
    this.staffer_id = this.$route.query.staffer_id;
    //
    console.log('this.$store.state.Slider',this.$store.state.Slider)
    this.slider = this.$store.state.Slider;
    // 初始化清空数据
    this.$Tool.removeStorage("company_id");
    this.$Tool.removeStorage("schoolItem");
    this.$Tool.removeStorage("school_id");
    this.$Tool.removeStorage("staffer_id");
    this.$Tool.removeStorage("userInfo");
    this.$Tool.removeStorage("Slider");
    this.$Tool.removeStorage("language");
    this.$Tool.setStorage(STORAGE_KEYS.IS_GRAY_SCHOOL, 0);
    this.$Tool.setStorage("navActiveIndex", "2");
    this.$store.dispatch("setNavActiveIndex", "2");
    // window.localStorage.clear();
    this.$Tool.setStorage(
      "re_postbe_id",
      this.$route.query.postbe_id ? this.$route.query.postbe_id : 0
    );
    this.$Tool.setStorage("sliderActiveIndex", "0-1");
    this.$store.dispatch("setActiveIndex", "0-1");
    this.$Tool.setStorage("openMenu", ["0"]);
    this.$store.dispatch("setOpenMenu", ["0"]);
    this.language_type = this.$route.query.language;
    this.$Tool.setStorage("language", this.language_type);
    this.isjump();
  },
  mounted() {},
  methods: {
    isjump() {
      axios
        .get(`${this.$Urls.crmApiUrl}/Login`, {
          params: {
            staffer_id: this.$route.query.staffer_id,
            token: this.$route.query.token,
            school_id: this.$route.query.school_id,
            company_id: this.$route.query.company_id,
            re_postbe_id: this.$route.query.postbe_id,
            language_type: this.$route.query.language,
          },
        })
        .then((res) => {
          const { code, data: _jb } = res.data;
          if (code !== 200) {
            this.$router.push("/noPermission");
          } else {
            var userInfo = _jb;
            saveGraySchoolFlag(userInfo, this.$Tool, 0);

            this.crmLoginData.token = userInfo.data.marketer_tokenencrypt;
            this.crmLoginData.re_postbe_id = this.$route.query.postbe_id;
            this.crmLoginData.company_id = userInfo.data.company_id;
            this.crmLoginData.marketer_id = userInfo.data.marketer_id;
            this.crmLoginData.staffer_id = this.staffer_id;
            this.crmLoginData.school_id = userInfo.data.school_id;
            this.crmLoginData.postbe_crmuserlevel =
              userInfo.data.postbe_crmuserlevel;
            this.crmLoginData.language_type = this.language_type;

            this.istemporaryclose =
              userInfo.school.school_istemporaryclose == 1;
            this.temporaryclosetip = userInfo.school.school_temporaryclosetip;

            this.$Tool.setStorage("token", userInfo.data.marketer_tokenencrypt);
            this.$store.dispatch(
              "setUserToken",
              userInfo.data.marketer_tokenencrypt
            );
            this.$Tool.setStorage("userInfo", userInfo.data); //存储用户信息
            this.$store.dispatch("setUserInfo", userInfo.data); //更新用户信息
            this.$Tool.setStorage("school_id", userInfo.data.school_id);
            this.$store.dispatch("setSchoolId", userInfo.data.school_id); //存储schoolid
            this.$Tool.setStorage("school_name", userInfo.data.school_cnname);
            this.$Tool.setStorage("company_id", userInfo.data.company_id);
            this.$store.dispatch("setCompanyId", userInfo.data.company_id);
            this.$Tool.setStorage("staffer_id", this.staffer_id);
            this.$Tool.setStorage("original_token", this.original_token);
            this.$store.dispatch("setStafferId", this.staffer_id); //存储staffer_id
            this.$store.dispatch("setUserOriginalToken", this.original_token);
            this.$Tool.setStorage(
              "PostbeCrmlevel",
              userInfo.data.postbe_crmuserlevel
            );
            this.$store.dispatch(
              "setPostbeCrmlevel",
              userInfo.data.postbe_crmuserlevel
            ); //更新权限信息
            this.$Tool.setStorage("marketer_id", userInfo.data.marketer_id); //存储schoolid

            this.jobs = userInfo.post; //职位权限信息

            if (this.jobs.length != 0) {
              this.isPowerNavList().then(() => {
                this.$Tool.removeStorage("schoolItem");
                //   this.$Tool.setStorage("userInfo", res.data.data);
                //   this.$store.dispatch("setUserInfo", res.data.data.data); //更新用户信息
                // (() => {})(this.$store.state.USER_INFO, 'state')
                if ("tokeninc" in userInfo) {
                  this.$message.error("用户token失效");
                  this.$router.push("/noPermission");
                } else {
                  if ("marketer_id" in userInfo.data && this.jobs.length == 0) {
                    if (userInfo.data.school_id == null) {
                      this.$message.error("您没有CRM权限");
                      this.$router.push("/noPermission");
                    }
                    if (!this.isChange) {
                      if (userInfo.data.postbe_crmuserlevel == "1") {
                        this.getModule().then(() => {
                          this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs); //职位权限信息
                          this.redirectCloseSchool();
                        });
                      } else {
                        this.getLowModuleList().then(() => {
                          this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs); //职位权限信息
                          this.redirectCloseSchool();
                        });
                      }
                    } else {
                      this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs); //职位权限信息
                      this.redirectCloseSchool();
                    }
                    // this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs); //职位权限信息
                    // this.redirectCloseSchool();
                  } else if (!("marketer_id" in userInfo.data)) {
                    this.$message.error("您没有CRM权限");
                    this.$router.push("/noPermission");
                  }
                }
              });
            } else {
              this.$Tool.setStorage(
                "PostbeCrmlevel",
                userInfo.data.postbe_crmuserlevel
              );
              this.$store.dispatch(
                "setPostbeCrmlevel",
                userInfo.data.postbe_crmuserlevel
              ); //更新权限信息

              if (userInfo.data.postbe_crmuserlevel == "1") {
                this.getModule().then(() => {
                  this.$Tool.removeStorage("schoolItem");
                  //   this.$Tool.setStorage("userInfo", res.data.data);

                  //   this.$store.dispatch("setUserInfo", res.data.data.data); //更新用户信息
                  // (() => {})(this.$store.state.USER_INFO, 'state')
                  if ("tokeninc" in userInfo) {
                    this.$message.error("用户token失效");
                    this.$router.push("/noPermission");
                  } else {
                    if (
                      "marketer_id" in userInfo.data &&
                      this.jobs.length == 0
                    ) {
                      if (userInfo.data.school_id == null) {
                        this.$message.error("您没有CRM权限");
                        this.$router.push("/noPermission");
                      }
                      if (!this.isChange) {
                        if (userInfo.data.postbe_crmuserlevel == "1") {
                          this.getModule().then(() => {
                            this.$Tool.setStorage(
                              "USER_ALL_ACCOUNTS",
                              this.jobs
                            ); //职位权限信息
                            this.redirectCloseSchool();
                          });
                        } else {
                          this.getLowModuleList().then(() => {
                            this.$Tool.setStorage(
                              "USER_ALL_ACCOUNTS",
                              this.jobs
                            ); //职位权限信息
                            this.redirectCloseSchool();
                          });
                        }
                      } else {
                        this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs); //职位权限信息
                        this.$Tool.setStorage(
                          "marketer_id",
                          userInfo.data.marketer_id
                        ); //存储schoolid
                        this.redirectCloseSchool();
                      }
                    } else if (!("marketer_id" in userInfo.data)) {
                      this.$message.error("您没有CRM权限");
                      this.$router.push("/noPermission");
                    }
                  }
                });
              } else {
              // } else if (userInfo.data.postbe_crmuserlevel == "0") {
                this.getLowModuleList().then(() => {
                  this.$Tool.removeStorage("schoolItem");
                  //   this.$store.dispatch("setUserInfo", res.data.data.data); //更新用户信息
                  // (() => {})(this.$store.state.USER_INFO, 'state')
                  if ("tokeninc" in userInfo) {
                    this.$message.error("用户token失效");
                    this.$router.push("/noPermission");
                  } else {
                    if (
                      "marketer_id" in userInfo.data &&
                      this.jobs.length == 0
                    ) {
                      if (userInfo.data.school_id == null) {
                        this.$message.error("您没有CRM权限");
                        this.$router.push("/noPermission");
                      }
                      if (!this.isChange) {
                        if (userInfo.data.postbe_crmuserlevel == "1") {
                          this.getModule().then(() => {
                            this.$Tool.setStorage(
                              "USER_ALL_ACCOUNTS",
                              this.jobs
                            ); //职位权限信息
                            this.$Tool.setStorage(
                              "marketer_id",
                              userInfo.data.marketer_id
                            ); //存储schoolid
                            this.redirectCloseSchool();
                          });
                        } else {
                          this.getLowModuleList().then(() => {
                            this.$Tool.setStorage(
                              "USER_ALL_ACCOUNTS",
                              this.jobs
                            ); //职位权限信息
                            this.$Tool.setStorage(
                              "marketer_id",
                              userInfo.data.marketer_id
                            ); //存储schoolid
                            this.redirectCloseSchool();
                          });
                        }
                      } else {
                        this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs); //职位权限信息
                        this.$Tool.setStorage(
                          "marketer_id",
                          userInfo.data.marketer_id
                        ); //存储schoolid
                        this.redirectCloseSchool();
                      }
                    } else if (!("marketer_id" in userInfo.data)) {
                      this.$message.error("您没有CRM权限");
                      this.$router.push("/noPermission");
                    }
                  }
                });
              }
            }
          }
          this.$Tool.setStorage("status", res.data.data.status); //判断是否可以切换至校务
        });
    },

    redirectCloseSchool() {
      if (this.istemporaryclose) {
        this.$Tool.setStorage(
          "SchoolTemporaryCloseTip",
          this.temporaryclosetip
        );
        window.location = "/temporaryClosure";
      } else {
        this.Countdown();
      }
    },
    // 获取 权限列表(切换职务)
    getCrmLevel(id) {
      return new Promise((resolve) => {
        storePermission
          .getCrmLevel({
            token: this.crmLoginData.token,
            re_postbe_id: this.crmLoginData.re_postbe_id,
            company_id: this.crmLoginData.company_id,
            marketer_id: this.crmLoginData.marketer_id,
            staffer_id: this.crmLoginData.staffer_id,
            school_id: this.crmLoginData.school_id,
            postbe_crmuserlevel: this.crmLoginData.postbe_crmuserlevel,
            module_class: 3,
            postbe_id: id,
          })
          .then((res) => {
            if (res.data.code === 200) {
              let { children } = res.data.data;
              this.$Tool.setStorage("Slider", children);
              this.$store.dispatch("setSlider", children);
              this.$Tool.setStorage(
                "PostbeCrmlevel",
                res.data.data.level.postbe_crmuserlevel
              );
              this.$store.dispatch(
                "setPostbeCrmlevel",
                res.data.data.level.postbe_crmuserlevel
              ); //更新权限信息
            }
            resolve();
          });
      });
    },
    // 判断 切换 用户角色
    isPowerNavList() {
      return new Promise((resolve) => {
        let account = null;
        let storageAccount = this.$Tool.getStorage("CURRENT_USER_ACCOUNTS");
        this.$Tool.setStorage("USER_ALL_ACCOUNTS", this.jobs);
        if (storageAccount) {
          let postbe_id = storageAccount.postbe_id,
            haveSameId = false,
            index = -1;
          (() => {})(postbe_id, 13232434);
          this.jobs.forEach((e, i) => {
            if (e.postbe_id == postbe_id) {
              haveSameId = true;
              index = i;
            }
          });
          if (haveSameId) {
            account = this.jobs[index];
          } else {
            account = this.jobs[0];
          }
        } else {
          account = this.jobs[0];
        }
        (() => {})(account);
        this.$Tool.setStorage("CURRENT_USER_POSTID", account.postbe_id);
        this.$Tool.setStorage("userInfo", account); //存储用户信息
        this.$store.dispatch("setUserInfo", account); //更新用户信息

        this.radioIndex = account.postbe_id;
        this.isChange = this.$Tool.getStorage("IS_CHANGE");

        this.$Tool.setStorage("school_id", account.school_id);
        this.$store.dispatch("setSchoolId", account.school_id); //存储schoolid
        this.$Tool.setStorage("school_name", account.school_cnname);
        this.$Tool.setStorage("company_id", account.company_id);
        this.$store.dispatch("setCompanyId", account.company_id);
        this.$Tool.setStorage("token", account.marketer_tokenencrypt);
        this.$store.dispatch("setUserToken", account.marketer_tokenencrypt);
        this.$Tool.setStorage("marketer_id", account.marketer_id); //存储schoolid

        this.$Tool.setStorage("staffer_id", account.staffer_id);
        this.$store.dispatch("setStafferId", account.staffer_id); //存储staffer_id
        this.$Tool.setStorage("PostbeCrmlevel", account.postbe_crmuserlevel);
        this.$store.dispatch("setPostbeCrmlevel", account.postbe_crmuserlevel);

        this.getCrmLevel(this.radioIndex).then(() => {
          this.Countdown(resolve);
          resolve();
        });
      });
    },
    // 获取 权限列表*****postbe_crmuserlevel=1
    getModule() {
      return new Promise((resolve) => {
        storePermission
          .getModule({
            token: this.crmLoginData.token,
            re_postbe_id: this.crmLoginData.re_postbe_id,
            company_id: this.crmLoginData.company_id,
            marketer_id: this.crmLoginData.marketer_id,
            staffer_id: this.crmLoginData.staffer_id,
            school_id: this.crmLoginData.school_id,
            postbe_crmuserlevel: this.crmLoginData.postbe_crmuserlevel,
            module_class: 3,
          })
          .then((res) => {
            (() => {})(res.data.data);
            if (res.data.code === 200) {
              const { children } = res.data.data;
              this.$store.dispatch("setSlider", children);
              this.$Tool.setStorage("Slider", children);
              // this.$Tool.setStorage("IS_CHANGE", false);
              // // this.$router.replace({ path: "/" });
              // window.location = `${this.$Urls.wpcUrl}/choose?token=${
              //   this.token
              // }&staffer_id=${this.sid}&company_id=${this.cid}&school_id=${
              //   this.schid
              // }`;
              // this.$router.replace({
              //   path: `/havePermission?token=${this.token}&staffer_id=${
              //     this.sid
              //   }&company_id=${this.cid}&school_id=${this.schid}`
              // });
            }
            resolve();
          });
      });
    },
    // 获取 权限列表*****postbe_crmuserlevel=0
    getLowModuleList() {
      return new Promise((resolve) => {
        storePermission
          .getLowModuleList({
            token: this.crmLoginData.token,
            re_postbe_id: this.crmLoginData.re_postbe_id,
            company_id: this.crmLoginData.company_id,
            marketer_id: this.crmLoginData.marketer_id,
            staffer_id: this.crmLoginData.staffer_id,
            school_id: this.crmLoginData.school_id,
            postbe_crmuserlevel: this.crmLoginData.postbe_crmuserlevel,
            module_class: 3,
          })
          .then((res) => {
            (() => {})(res.data.data);
            if (res.data.code === 200) {
              const { children } = res.data.data;
              this.$store.dispatch("setSlider", children);
              this.$Tool.setStorage("Slider", children);
              // this.$Tool.setStorage("IS_CHANGE", false);
              // // this.$router.replace({ path: "/" });
              // window.location = `${this.$Urls.wpcUrl}/choose?token=${
              //   this.token
              // }&staffer_id=${this.sid}&company_id=${this.cid}&school_id=${
              //   this.schid
              // }`;
              // this.$router.replace({
              //   path: `/havePermission?token=${this.token}&staffer_id=${
              //     this.sid
              //   }&company_id=${this.cid}&school_id=${this.schid}`
              // });
            }
            resolve();
          });
      });
    },

    //首页-链接跳转权限-接口
    ChangeUrl(url, urlChild) {
      console.log('url333',url)
      storeHome
        .ChangeUrl({
          token: this.crmLoginData.token,
          // re_postbe_id: this.crmLoginData.re_postbe_id,
          company_id: this.crmLoginData.company_id,
          marketer_id: this.crmLoginData.marketer_id,
          staffer_id: this.crmLoginData.staffer_id,
          school_id: this.crmLoginData.school_id,
          postbe_crmuserlevel: this.crmLoginData.postbe_crmuserlevel,
          url: url ? url.split("?")[0] : "", //模块的url
          module_class: 3,
          re_postbe_id: this.$route.query.postbe_id,
        })
        .then((res) => {
          console.log('res222',res)
          if (res.data.code === 200) {
            const payload = res.data.data;
            var data = payload.children;
            var id = payload.module.module_id;
            var father_id = payload.module.father_id;
            data.forEach((item) => {
              item.children.forEach((item1) => {
                if (item1.children) {
                  item1.children.forEach((item2) => {
                    if (
                      item2.module_markurl ==
                      (url.substring(url.indexOf("?"), 0) || url)
                    ) {
                      alert('444')
                      this.$Tool.setStorage("innerSlider", item1.children);
                      this.$store.dispatch("setInnerSlider", item1.children);
                      this.$Tool.setStorage(
                        "sliderActiveIndex",
                        item1.activeIndex
                      );
                      this.$store.dispatch("setActiveIndex", item1.activeIndex);
                      this.$Tool.setStorage("openMenu", ["" + item.index]);
                      this.$store.dispatch("setOpenMenu", ["" + item.index]);
                      this.$Tool.setStorage("module_id", father_id);
                      this.$store.dispatch("setModuleId", father_id);

                      if (urlChild) {
                        this.$router.push(urlChild);
                      } else {
                        this.$router.push(url);
                      }
                    }
                  });
                } else {
                  if (item1.module_markurl == url.split("?")[0]) {
                    this.$Tool.removeStorage("innerSlider");
                    this.$store.dispatch("setInnerSlider", []);
                    this.$Tool.setStorage(
                      "sliderActiveIndex",
                      item1.activeIndex
                    );
                    this.$store.dispatch("setActiveIndex", item1.activeIndex);
                    this.$Tool.setStorage("openMenu", ["" + item.index]);
                    this.$store.dispatch("setOpenMenu", ["" + item.index]);
                    this.$Tool.setStorage("module_id", id);
                    this.$store.dispatch("setModuleId", id);

                    if (urlChild) {
                      this.$router.push(urlChild);
                    } else {
                      this.$router.push(url);
                    }
                  }
                }
              });
            });
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        });
    },
    jump() {
      if (this.isPush) return;
      let url = this.$route.query.tourl
        ? decodeURIComponent(this.$route.query.tourl)
        : "";
      clearInterval(this.timer);
      if (url && !this.isPush) {
        this.isPush = true;
        this.ChangeUrl(url);
      } else {
        this.isPush = true;
        window.location = url ? url : "/home";
      }
      // let url = this.$route.query.tourl;
      // window.location = url ? url : "/home";
    },
    Countdown(resolve) {
      // this.timer = setInterval(() => {
      //   if (this.time > 1) {
      //     this.time--;
      //   } else {
      //     clearInterval(this.timer);
      let url = this.$route.query.tourl
        ? decodeURIComponent(this.$route.query.tourl)
        : "";
      if (url && !this.isPush) {
        this.isPush = true;
        this.ChangeUrl(url);
      } else {
        this.isPush = true;
        window.location = url ? url : "/home";
      }
      resolve && resolve();
      //   }
      // }, 1000);
    },
  },
};
</script>

<style lang="less">
.havePermission {
  height: 100vh;
  font-size: 20px;
  //悬浮框
  .slider_nav_box {
    display: none;
  }
  .el-header {
    display: none;
  }

  .el-aside {
    display: none;
  }

  .el-main {
    background: #fff;
  }
}

.page-havePermission {
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .title {
    font-size: 26px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: rgba(51, 51, 51, 1);
    line-height: 37px;
  }

  .time {
    color: rgba(208, 2, 27, 1);
    font-weight: 500;
  }

  .img {
    width: 250px;
    background: #fff;
    margin: 30px auto 20px auto;
    padding: 15px 30px;

    img {
      width: 100%;
    }
  }

  button {
    margin-top: 20px;
  }
}
// 1366*768
// @media screen and (max-width: 1366px) {
//   .page-havePermission {
//     padding-top: 10%;
//   }
// }
</style>
